import Marionette from "backbone.marionette";

import FaqtancesTpl from "views/faq/faqView.ejs";

import CSS from "views/faq/faq.css";

import S from "session/session.js";
import T from "session/token.js";

require('jquery-equalheights');

export default Marionette.LayoutView.extend({
    initialize: function() {
        console.log("----- extendee---11-- ");
        $('.content-wrapper').css({ 'margin-left': '230px' });


        this.listenTo(this.model, "sync", this.applyView.bind(this));

        console.log("----- extendee--enddddddd- ");
    },
    template: FaqtancesTpl,
    render: function() {
        console.log("----- renderrrr--1111333--- ");

        $("#backButton").removeClass("hidden");


        S.userInfo.set({
            options: S.enviroMenu
        });

        // Show usuarios y entornos
        $("a#USERS, a#ENVIRO, a#COMPANIES").parent().hide(); // Sidebar            

        /////this.$el.html(this.template({}));

        this.applyView();

        console.log("----- renderrrr--enddddddddd--- ");

    },
    applyView: function() {
        console.log("----- applyyyyyy---2222222333-- ");

        $("#backButton").removeClass("hidden");

        S.userInfo.set({
            options: S.enviroMenu
        });

        this.$el.html(this.template({}));

        $("a#USERS, a#ENVIRO, a#COMPANIES").parent().hide(); // Sidebar            

        console.log("----- applyyyyyy---endddddddddd 333-- ");
    },
    events: {
        "click #addInstance": "addInstance",
        "click .instanceItem": "select",
        "click .editInstanceItem": "edit"
    },

    select: function(ev) {
        S.instanceId = $(ev.target).attr("data-id");
        // window.top.location = "#menu";
        window.top.location = "#planos/planos_1176";
        //window.top.location = "#planos"; 
    },


});


//////////////////
// WEBPACK FOOTER
// ./app/views/faq/faqView.js
// module id = 182
// module chunks = 0